import config from "./config.json";

export const SITE_ORIGIN = config.origin;

export function getPageMetadata(pathname, search = "") {
  const path = pathname.replace(/\/+$/, "") || "/";
  if (path === "/catalogue") {
    const category = new URLSearchParams(search).get("cat");
    if (Object.prototype.hasOwnProperty.call(config.categories, category) && category !== "cars") {
      return { ...config.categories[category], canonicalPath: `${path}?cat=${category}` };
    }
  }
  return { ...(config.pages[path] || config.pages["/"]), canonicalPath: path };
}

export function getProductDescription(name, description) {
  const text = typeof description === "string" ? description.trim() : "";
  if (text && !/^описание временно отсутствует[.!]?$/i.test(text)) {
    return text;
  }
  return `${name}. Фотографии, характеристики и условия приобретения в General Trucks. Уточните цену и статус автомобиля у менеджера.`;
}
